import Cta from "Components/Cta/Cta";

export default Cta;
